import { Box, Flex } from "@chakra-ui/layout";
import { Button, SystemStyleObject } from "@chakra-ui/react";
import React from "react";
import { TableBox } from "shared/components/table/box/TableBox";

interface RefreshableTableBoxProps {
  refreshTitle: string;
  shouldRefresh: boolean;
  onRefreshClick(): void;
  tableBoxProps?: React.ComponentProps<typeof TableBox>;
  sx?: SystemStyleObject;
}
export const RefreshableTableBox: React.FC<
  React.PropsWithChildren<RefreshableTableBoxProps>
> = ({
  refreshTitle,
  onRefreshClick,
  tableBoxProps,
  shouldRefresh,
  children,
  sx,
}) => (
  <Box position="relative" sx={sx}>
    <TableBox
      boxProps={
        shouldRefresh
          ? {
              sx: { opacity: "50%", pointerEvents: "none" },
            }
          : undefined
      }
      {...tableBoxProps}
    >
      {children}
    </TableBox>
    {shouldRefresh && (
      <Flex position="absolute" top="50%" width="100%">
        <Button colorScheme="tertiary" margin="0 auto" onClick={onRefreshClick}>
          {refreshTitle}
        </Button>
      </Flex>
    )}
  </Box>
);
